import * as TYPE from "@/store/modules/header/type";
import * as HEADER_TYPE from "@/store/modules/header/type";
import IConstants from "@/common/constants/IConstants";
import MobileDetect from "mobile-detect";
import ServiceUtils from "@/common/utils/ServiceUtils.js";
import {createNamespacedHelpers} from "vuex";

const { mapActions } = createNamespacedHelpers('header');

const cryptoRedirectMixin = {
    data() {
        return {
            postDocTemplate: {}
        }
    },
    methods: {
        ...mapActions([TYPE.SET_ACTIVE_TAB_ID]),
        async redirectCryptoRegistration(linksAppList) {
            const service = this.$service.getService("cryptoRegistration");
            const registerInitResponse = await service.cryptoRegisterInit();

            if (registerInitResponse === null || registerInitResponse.errorMessage !== null) {
                return this.$router.push({name: "cryptoRegistrationForm"});
            }

            switch (registerInitResponse.redirect) {
                case null :
                    if (registerInitResponse.ageLimit) {
                        this.$modal.showAgeLimitMsg(registerInitResponse.ageLimit);
                        this[TYPE.SET_ACTIVE_TAB_ID](HEADER_TYPE.MENU_HOME);
                        return this.$router.push({name: "index"});
                    }
                    return this.$router.push({name: "cryptoRegistrationForm"});
                    
                case IConstants.CRYPTO_PAGE.STATIC_PAGE_1:
                    return this.$router.push({name: "cryptoStaticPage1"});

                case IConstants.CRYPTO_PAGE.STATIC_PAGE_2:
                    return this.$router.push({name: "cryptoStaticPage2"});

                case IConstants.CRYPTO_PAGE.STATIC_PAGE_3:
                    this.postDocTemplate = registerInitResponse.postDocTemplate || {}
                    return this.$router.push({name: "cryptoStaticPage3"});

                case IConstants.CRYPTO_PAGE.STATIC_PAGE_4:
                    this.postDocTemplate = registerInitResponse.postDocTemplate || {}
                    return this.$router.push({name: "cryptoStaticPage4"});

                case IConstants.CRYPTO_PAGE.UPLOAD_DOCUMENT:
                    this.postDocTemplate = registerInitResponse.postDocTemplate || {}
	                return this.$router.push({name: "cryptoUploadDocument"});

                default: {
                	// why "default" block has "{}" while others don't : to declare const/variable inside
	                const userAgent = window.navigator.userAgent;
	                const mobileDetect = new MobileDetect(userAgent);
	                const mobileMode = mobileDetect.mobile();
	                const tabletMode = mobileDetect.tablet();
    
                    let tabletModeHugeSize= false;
                    if (tabletMode && window.innerHeight < window.innerWidth) {
                        tabletModeHugeSize = true;
                    }
	                
	                if (registerInitResponse.redirect.lastIndexOf('http') >= 0 || registerInitResponse.redirect.lastIndexOf('https') >= 0) {
		                if (!mobileMode && !tabletMode || tabletModeHugeSize) {
			                window.location.href = registerInitResponse.redirect;
		                } else {
			                if (linksAppList) {
				                const isAndroid = mobileDetect.is("AndroidOS");
				                const isIOS = mobileDetect.is("iOS");
				                const IOSVersion = mobileDetect.version('iOS');
				                ServiceUtils.openMobileApp(linksAppList.CRYPT_UNIVERSAL_LINK_URL, linksAppList.CRYPT_APPSTORE_URL, null, null,
					                linksAppList.CRYPT_DEEP_LINK_URL, linksAppList.CRYPT_OPENAPP_ANDROID_URL, isIOS, isAndroid, IOSVersion);
                            } else {
                                window.location.href = registerInitResponse.redirect;
                            }
		                }
	                }
	                return;
                }
            }
        }
    }
};
export default cryptoRedirectMixin;
